module.exports = __webpack_public_path__ + "static/media/oberflex-bamboufinnaturel-2560x1440.757b746f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-bamboufinnaturel-2560x1440.jpg
// module id = 983
// module chunks = 37